<template>
  <div class="user-stats">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>用户统计</span>
        </div>
      </template>
      <div class="stats-grid">
        <el-card class="stats-card">
          <div class="stats-item">
            <div class="stats-value">{{ totalUsers }}</div>
            <div class="stats-label">总用户数</div>
          </div>
        </el-card>
        <el-card class="stats-card">
          <div class="stats-item">
            <div class="stats-value">{{ todayUsers }}</div>
            <div class="stats-label">今日新增</div>
          </div>
        </el-card>
        <el-card class="stats-card">
          <div class="stats-item">
            <div class="stats-value">{{ activeUsers }}</div>
            <div class="stats-label">活跃用户</div>
          </div>
        </el-card>
        <el-card class="stats-card">
          <div class="stats-item">
            <div class="stats-value">{{ maleUsers }}</div>
            <div class="stats-label">男性用户</div>
          </div>
        </el-card>
        <el-card class="stats-card">
          <div class="stats-item">
            <div class="stats-value">{{ femaleUsers }}</div>
            <div class="stats-label">女性用户</div>
          </div>
        </el-card>
        <el-card class="stats-card">
          <div class="stats-item">
            <div class="stats-value">{{ avgAge }}</div>
            <div class="stats-label">平均年龄</div>
          </div>
        </el-card>
      </div>
      <el-card class="stats-card" style="margin-top: 20px;">
        <template #header>
          <div class="card-title">用户增长趋势</div>
        </template>
        <div class="chart-container">
          <!-- 这里应该是图表，暂时使用模拟数据 -->
          <div class="chart-placeholder">
            <div class="trend-chart">
              <div class="trend-item" style="height: 30%"></div>
              <div class="trend-item" style="height: 45%"></div>
              <div class="trend-item" style="height: 35%"></div>
              <div class="trend-item" style="height: 60%"></div>
              <div class="trend-item" style="height: 50%"></div>
              <div class="trend-item" style="height: 75%"></div>
              <div class="trend-item" style="height: 85%"></div>
            </div>
          </div>
        </div>
      </el-card>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UserStats',
  data() {
    return {
      totalUsers: 1234,
      todayUsers: 12,
      activeUsers: 456,
      maleUsers: 789,
      femaleUsers: 445,
      avgAge: 25
    }
  },
  mounted() {
    this.fetchUserStats()
  },
  methods: {
    fetchUserStats() {
      try {
        // 这里应该调用API获取统计数据
        // 暂时使用模拟数据
      } catch (error) {
        this.$message.error('获取用户统计数据失败')
      }
    }
  }
}
</script>

<style scoped>
.user-stats {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.stats-card {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stats-item {
  text-align: center;
}

.stats-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.stats-label {
  font-size: 14px;
  color: #606266;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
}

.chart-container {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.trend-chart {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  height: 200px;
  width: 100%;
  padding: 0 20px;
}

.trend-item {
  flex: 1;
  background-color: #67c23a;
  border-radius: 5px 5px 0 0;
  min-height: 20px;
}
</style>
